import { render, staticRenderFns } from "./RegistrarBoleta.vue?vue&type=template&id=09025abb"
import script from "./RegistrarBoleta.vue?vue&type=script&lang=js"
export * from "./RegistrarBoleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports